import {
  toDataSourceRequestString,
  translateDataSourceResultGroups,
} from "@progress/kendo-data-query";
import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";
import {
  defaultAlertMessages,
  getConfirmErrorMessage,
  getConfirmSuccessMessage,
} from "../../utils/common";
import { confirmAlert } from "react-confirm-alert";
import { getAccessToken } from "../../helpers/authConfig";

class EventService {
  getList(dataState) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/Etkinlik/get-list-by-filter?${toDataSourceRequestString(dataState)}`,
      )
      .then((response) => {
        return dataState.group && dataState.group.length
          ? translateDataSourceResultGroups(response.data)
          : { data: response.data, dataState };
      });
  }
  getEventsForExcel(dataState) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/etkinlik/get-list-for-excel?${toDataSourceRequestString(dataState)}`,
      )
      .then((response) => response.data);
  }

  async getEvent(id) {
    const token = await getAccessToken();
    return axios
      .get(`${API_GATEWAY + PR_DEP}/Etkinlik/get-by-id/${id}`, {
        headers: {
          "Azure-Token": token,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data.message,
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  async addEvent(data) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/etkinlik/add`, data)
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data,
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  async updateEvent(data) {
    const token = await getAccessToken();
    return axios
      .post(`${API_GATEWAY + PR_DEP}/etkinlik/update`, data, {
        headers: {
          "Content-Type": "application/json",
          "Azure-Token": token,
        },
      })
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.data.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data,
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  async addEventToCompanyCalendar(etkinlikTanimId) {
    const token = await getAccessToken();
    return axios
      .post(
        `${API_GATEWAY + PR_DEP}/etkinlik/add-event-company-calendar`,
        { ETKINLIK_TANIM_ID: etkinlikTanimId },
        {
          headers: {
            "Content-Type": "application/json",
            "Azure-Token": token,
          },
        },
      )
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data,
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }
}

export default new EventService();
